<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="TruckIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('SIM Information') }}
      </h4>
    </div>

    <b-row class="mt-2">
      <b-col cols="12" md="6">
        <b-form-group :label="$t('SIM Number')" label-for="simNumber-id">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="data.simNumber" id="simNumber-id" :state="errors && ('simNumber' in errors) ? false : null"
              :placeholder="$t('SIM Number')" />
          </b-input-group>
          <small v-if="errors && ('simNumber' in errors)" class="text-danger">
            {{ $t(errors['simNumber'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group :label="$t('Protocol')" label-for="protocol-id">
          <v-select 
            v-model="data.protocol_id" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" 
            :options="protocols" 
            :reduce="protocol => protocol.id" />
          <small v-if="errors && ('protocol_id' in errors)" class="text-danger">
            {{ $t(errors['protocol_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <b-col md="6" xl="2" class="mb-1">
        <b-form-group :label="$t('Send Message')" label-for="send-message-id">
          <b-form-checkbox v-model="data.sendMessage" :value="true" />
        </b-form-group>
      </b-col>

    </b-row>

  </div>
</template>

<script>

import {
  BButton, 
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, 
  BInputGroupPrepend, 
  BRow, 
  BAlert, 
  BFormCheckbox
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, ref } from '@vue/composition-api'
import store from '@/store'
import axios from '@/libs/axios'


export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BFormCheckbox,
    vSelect,
    OrbitSpinner
  },

  setup() {

    const device = store.state.device

    const data = computed(() => device.data)
    const errors = computed(() => device.errors)

    const protocols = ref([])

    axios.get('protocols')
      .then(response => protocols.value = response.data)
      .catch(error => console.log(error))

    return {
      protocols,
      data,
      errors
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: visible;
  transition:
    .35s height;
}

.v-select .vs__selected-options {
  flex-wrap: nowrap;
}
</style>
